import { createFileRoute } from '@tanstack/react-router';
import { legacyRedirect } from './-components';

// The old `journeys` URL for Profile activity. The page lives at `/workspaces/:workspaceId/profile_activity`.
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/profile_activity/')({
  beforeLoad: legacyRedirect('/workspaces/:workspaceId/profile_activity/identified'),
});
